'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchBoxContainer = undefined;

var _reactRedux = require('react-redux');

var _device = require('redux/modules/device');

var _Search = require('../Search.reducer');

var _SearchBox = require('./SearchBox.reducer');

var _SearchBox2 = require('./SearchBox');

var mapStateToProps = function mapStateToProps(state) {
  return {
    openPanel: (0, _SearchBox.selectOpenPanel)(state),
    mediaQueryLg: (0, _device.selectMediaState)(state).lg
  };
};

var mapDispatchToProps = {
  onPanelClose: _SearchBox.closeOpenPanel,
  onToggleMapView: _Search.setMapView
};

var SearchBoxContainer = exports.SearchBoxContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_SearchBox2.SearchBox);